import {LegacyCard, Pagination} from "@shopify/polaris";

export const Paginator = ({ collection = [], meta, callback, customerId}) => {
    if (! collection.length) {
        return null;
    }

    return (
        <LegacyCard.Section>
            <Pagination
                label={`Showing Page ${meta.current_page} of ${meta.last_page}`}
                hasPrevious={ meta.current_page > 1}
                onPrevious={() => { callback(customerId, meta.current_page - 1) }}
                hasNext={ meta.current_page < meta.last_page }
                onNext={() => { callback(meta.current_page + 1) }} />
        </LegacyCard.Section>
    )
}
